/** Presentation only. Was duplicated verbatim in CatalogPage.jsx and ReviewPanel.jsx. */
export function formatDollars(amount) {
  if (amount === null || amount === undefined || Number.isNaN(amount)) return '—';
  const sign = amount < 0 ? '-' : '';
  const abs = Math.abs(amount);
  return `${sign}$${abs.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** A discount impact row carries a FRACTION (0.3), not dollars — see
 *  `ImpactRow.kind` (previewImpact.ts). Passing one to formatDollars would
 *  render "$0.30", which reads as thirty cents off. */
function formatPercent(fraction) {
  if (fraction === null || fraction === undefined || Number.isNaN(fraction)) return '—';
  const sign = fraction < 0 ? '-' : '';
  return `${sign}${(Math.abs(fraction) * 100).toFixed(2)}%`;
}

const IMPACT_KIND_LABEL = { price: 'Price', discount: 'Discount' };

/** Formats an impact row's three numbers in ITS OWN units. Unknown kinds fall
 *  back to the dollar formatter and a raw label rather than throwing: this is
 *  the review screen, and a movement rendered oddly is strictly better than a
 *  movement that crashes the panel it was meant to warn about. */
export function impactDisplay(row) {
  const format = row.kind === 'discount' ? formatPercent : formatDollars;
  return {
    what: IMPACT_KIND_LABEL[row.kind] ?? row.kind ?? 'Price',
    before: format(row.before),
    after: format(row.after),
    delta: row.delta === null || row.delta === undefined ? '—' : format(row.delta),
  };
}
